const AboutContainer = () => {
    return (<>Soy el AboutContainer</>)
}

export default AboutContainer;